<template>
  <div class="wrapper" :class="[{'nav-open': $sidebar.showSidebar}]">
    <notifications></notifications>
    <side-bar title="Administração" :auto-close="false" logo="/img/logo.png" background-color="white" background-image>
      <!-- <user-menu></user-menu> -->
      <mobile-menu></mobile-menu>
      <template slot="links">
        <template v-for="route in primaryRoutes">
          <sidebar-item :key="route.path" :link="{ name: route.name, icon: route.meta.icon, path: `/${route.path}` }" v-if="allowedModules.includes(route.meta.dashboardModule)"></sidebar-item>
        </template>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./DashboardLayoutComponents/TopNavbar.vue";
import ContentFooter from "./DashboardLayoutComponents/ContentFooter.vue";
import MobileMenu from "./DashboardLayoutComponents/MobileMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";

import permissionModel from "@/models/permission.model";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    ZoomCenterTransition,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    async loadRoutesPermissions() {
      if (!this.permissions) {
        return;
      }
      this.primaryRoutes.forEach((primaryRoute) => {
        const permission = this.permissions.find(permission => permission.dashboardModule === primaryRoute.meta.dashboardModule);
        if (permission) {
          if (!primaryRoute.meta) {
            primaryRoute.meta = {};
          }
          this.$set(primaryRoute.meta, 'permissionType', permission.permissionType);
          primaryRoute.children?.forEach((childRoute) => {
            if (!childRoute.meta) {
              childRoute.meta = {};
            }
            this.$set(childRoute.meta, 'permissionType', permission.permissionType);
          });
        }
      });
    },
  },
  async mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
    try {
      this.permissions = await permissionModel.getMyPermissions();
      await this.loadRoutesPermissions();
    } catch (error) {
      console.error(error);
      this.$toasted.error('Ocorreu um erro ao consultar suas permissões. Recarregue a página.')
    }
  },
  computed: {
    allowedModules() {
      if (!this.permissions) {
        return [];
      }
      return this.permissions.map(permission => permission.dashboardModule);
    }
  },
  created() {},
  data() {
    return {
      primaryRoutes: this.$router.options.routes[1].children,
      permissions: [],
    };
  },
};
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.logo-img img {
  width: 80% !important;
  padding-bottom: 4px;
}

.sidebar {
  .nav p {
    font-size: 0.9rem;
    font-weight: 600;
    color: #0C4DA2;
  }

  .nav .md-icon.md-theme-default.md-icon-font {
    color: #0C4DA2;
  }

  a.nav-item.active > p,
  a.nav-item.active > span,
  a.nav-item.active > i {
    color: white !important;
    opacity: 1 !important;
  }
}

.subroute-link {
  p {
    margin: 4px;
    font-size: 0.7rem;
    font-weight: 700;
    line-height: 0.8rem;
    color: #0C4DA2;
  }

  i.md-icon.md-icon-font.md-theme-default {
    color: #0C4DA2;
  }

  &.active > p,
  &.active > i {
    color: white !important;
    opacity: 1 !important;
  }

  &.active {
    background-color: #0C4DA2;
  }
}

</style>
